/**
 * Polityka haseł — lustro walidacji backendu (`App\Validator\CustomPasswordValidator`,
 * oparte o Rollerworks PasswordRequirements):
 *   - minimalna długość  = APP_MIN_PASSWORD_LENGTH (backend, domyślnie 10),
 *   - requireCaseDiff    = wielka i mała litera,
 *   - requireNumbers     = co najmniej jedna cyfra,
 *   - requireSpecialCharacter = co najmniej jeden znak spoza liter i cyfr.
 *
 * Dzięki temu użytkownik dostaje konkretny komunikat od razu przy polu, zamiast
 * dowiadywać się o niezgodności dopiero z odpowiedzi 400 serwera. Backend i tak
 * waliduje po swojemu — to jest wyłącznie wcześniejsza informacja zwrotna.
 *
 * Długość bierzemy z `VUE_APP_MIN_PASSWORD_LENGTH`; wartość musi być zgodna
 * z `APP_MIN_PASSWORD_LENGTH` w konfiguracji backendu.
 */

const DEFAULT_MIN_LENGTH = 10;

const parsed = Number.parseInt(process.env.VUE_APP_MIN_PASSWORD_LENGTH, 10);
export const MIN_PASSWORD_LENGTH =
  Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_MIN_LENGTH;

// Wyrażenia przepisane 1:1 z PasswordRequirementsValidator (PHP, modyfikator /u).
const CASE_DIFF = /(\p{Ll}+.*\p{Lu})|(\p{Lu}+.*\p{Ll})/u;
const HAS_NUMBER = /\p{N}/u;
const HAS_SPECIAL = /[^\p{Ll}\p{Lu}\p{L}\p{N}]/u;

/**
 * Dokłada reguły polityki haseł do przekazanego łańcucha yup `string()`.
 *
 * @param {import('yup').StringSchema} schema bazowy schemat (np. z .required())
 * @param {(key: string, params?: object) => string} t tłumacz vue-i18n
 */
export function applyPasswordPolicy(schema, t) {
  return schema
    .min(MIN_PASSWORD_LENGTH, t('password-too-short', { length: MIN_PASSWORD_LENGTH }))
    .test('case-diff', t('password-requires-case-diff'), (value) =>
      !value || CASE_DIFF.test(value)
    )
    .test('has-number', t('password-requires-number'), (value) =>
      !value || HAS_NUMBER.test(value)
    )
    .test('has-special', t('password-requires-special'), (value) =>
      !value || HAS_SPECIAL.test(value)
    );
}
